import { render, staticRenderFns } from "./table-status.vue?vue&type=template&id=3a5a7ce9&"
import script from "./table-status.vue?vue&type=script&lang=js&"
export * from "./table-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports